/* eslint-disable @typescript-eslint/naming-convention */
export enum BodyContentTypesEnum {
    Text = 'TEXT',
    Image = 'IMAGE',
    Video = 'VIDEO'
}
